<template>
    <div class="w-100 mr-1">
        <b-col lg="12" md="12" sm="12">
        <h3 class="mb-1">Configuração das doses</h3>
        </b-col>
        <b-col lg="4" md="12" sm="12">
        <label for="id-tipo-dose-input" class="label_size_vacina">Aplicação*</label>
        <v-select
            id="id-tipo-dose-input"
            v-model="typeDose"
            :options="typeDoseOptions"
            label="text"
            value="value"
            placeholder="Selecione a aplicação"
            :clearable="false"
            @input="resetDoses"
        >
            <span slot="no-options">Nenhuma opção selecionável.</span>
        </v-select>
        <small
            v-if="errorApi.type"
            class="text-danger"
        >
            {{ errorApi.type }}
        </small>
        </b-col>
        <b-col class="scroll-card-dose" v-if="multi" lg="12" md="12" sm="12">
            <b-row
                  ref="row"
                  class="pb-2 pl-2 d-block d-lg-none-dose"
                >
            <b-col cols="12">
            <div v-for="(item, index) in invoiceData.items"
            :key="index" class="d-flex">
            <b-row class="flex-grow-1">
            <span class="mt-1">{{ index + 1 }}.</span>
            <b-col
                cols="12"
                lg="12"
                class="p-0"
            >
                <label for="dose-input" class="d-inline">Nome da dose</label>
                <v-select
                id="dose-input"
                v-model="item.dose"
                :options="itemsOptions"
                label="descricao"
                placeholder="Selecione a dose"
                :clearable="false"
                class="mr-2"
                @input="updateDoseList"
                >
                <template #selected-option="item">
                <span> {{ item.br_dose }} - {{ item.descricao }}</span>
                </template>
                <template #option="item">
                <span> {{ item.br_dose }} - {{ item.descricao }}</span>
                </template>
                <span slot="no-options">Nenhuma opção selecionável.</span>
                </v-select>
            </b-col>
            <b-col
                cols="12"
                lg="6"
                class="p-0"
            >
            <label for="dose-input" class="d-inline">Idade recomendada</label>
            <div class="d-flex mr-2">
                    <b-input-group
                    class="d-flex flex-nowrap mr-1"
                    >
                        <b-form-input
                        type="number"
                        v-model="item.numberSinceAgeRecomended"
                        placeholder="De"
                        min="1"
                        class="mw-50p"
                        />
                        <b-input-group-append>
                            <v-select
                            v-model="item.sinceAgeRecomended"
                            :options="dateOptions"
                            label="text"
                            :clearable="false"
                            class="date-select"
                            :searchable="false"
                            :reduce="(option => option.value)"
                            >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group
                    class="mx-50p"
                    >
                        <b-form-input
                        type="number"
                        v-model="item.numberUntilAgeRecomended"
                        placeholder="Até"
                        min="1"
                        class="mw-50p"
                        />
                        <b-input-group-append>
                            <v-select
                            v-model="item.untilAgeRecomended"
                            :options="dateOptions"
                            label="text"
                            :clearable="false"
                            class="date-select"
                            :searchable="false"
                            :reduce="(option => option.value)"
                            >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-col>
            <b-col
                cols="12"
                lg="6"
                class="p-0"
            >
            <label for="dose-input" class="d-inline">Idade recomendada</label>
            <div class="d-flex mr-2">
                    <b-input-group
                    class="d-flex flex-nowrap mr-1"
                    >
                    <b-form-input
                        type="number"
                        v-model="item.numberSinceAgeLimit"
                        placeholder="De"
                        min="1"
                        class="mw-50p"
                        />
                        <b-input-group-append>
                            <v-select
                            v-model="item.sinceAgeLimit"
                            :options="dateOptions"
                            label="text"
                            :clearable="false"
                            class="date-select"
                            :searchable="false"
                            :reduce="(option => option.value)"
                            >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group
                    class="mx-50p"
                    >
                        <b-form-input
                        type="number"
                        v-model="item.numberUntilAgeLimit"
                        placeholder="Até"
                        min="1"
                        class="mw-50p"
                        />
                        <b-input-group-append>
                            <v-select
                            v-model="item.untilAgeLimit"
                            :options="dateOptions"
                            label="text"
                            :clearable="false"
                            class="date-select"
                            :searchable="false"
                            :reduce="(option => option.value)"
                            >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-col>
            <b-col cols="12" class="p-0">
                <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-danger"
                @click="removeItem"
                v-if="index >= 2"
                class="mt-1"
                >
                    Remover
                </b-button>
            </b-col>
            </b-row>
            </div>
            </b-col>
            </b-row>
        <table
        class="table-dose mt-1 d-none d-lg-block-dose"
        >
        <caption class="d-none">Configuração de Doses</caption>
        <thead>
            <tr>
            <th class="w-15px pl-0 font-weight-normal"></th>
            <th class="col-3 pl-0 font-weight-normal">Nome da Dose</th>
            <th class="col-4 pl-0 font-weight-normal">Idade Recomendada</th>
            <th class="col-4 pl-0 font-weight-normal">Idade Limite</th>
            <th class="pl-0 font-weight-normal"></th>
            </tr>
        </thead>
        <tbody>
            <tr 
            v-for="(item, index) in invoiceData.items"
            :key="index"
            class="mb-1"
            >
            <td>{{ index + 1 }}.</td>
            <td>
                <v-select
                id="dose-input"
                v-model="item.dose"
                :options="itemsOptions"
                label="descricao"
                placeholder="Selecione a dose"
                :clearable="false"
                class="mr-2"
                @input="updateDoseList"
                >
                <template #selected-option="item">
                <span> {{ item.br_dose }} - {{ item.descricao }}</span>
                </template>
                <template #option="item">
                <span> {{ item.br_dose }} - {{ item.descricao }}</span>
                </template>
                <span slot="no-options">Nenhuma opção selecionável.</span>
                </v-select>
            </td>
            <td>
                <div class="d-flex mr-2">
                    <b-input-group
                    class="mx-50p mr-1"
                    >
                        <b-form-input
                        type="number"
                        v-model="item.numberSinceAgeRecomended"
                        placeholder="De"
                        min="1"
                        class="mw-50p"
                        />
                        <b-input-group-append>
                            <v-select
                            v-model="item.sinceAgeRecomended"
                            :options="dateOptions"
                            label="text"
                            :clearable="false"
                            class="date-select"
                            :searchable="false"
                            :reduce="(option => option.value)"
                            >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group
                    class="mx-50p"
                    >
                        <b-form-input
                        type="number"
                        v-model="item.numberUntilAgeRecomended"
                        placeholder="Até"
                        min="1"
                        class="mw-50p"
                        />
                        <b-input-group-append>
                            <v-select
                            v-model="item.untilAgeRecomended"
                            :options="dateOptions"
                            label="text"
                            :clearable="false"
                            class="date-select"
                            :searchable="false"
                            :reduce="(option => option.value)"
                            >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </td>
            <td>
                <div class="d-flex mr-2">
                    <b-input-group
                    class="mx-50p mr-1"
                    >
                        <b-form-input
                        type="number"
                        v-model="item.numberSinceAgeLimit"
                        placeholder="De"
                        min="1"
                        class="mw-50p"
                        />
                        <b-input-group-append>
                            <v-select
                            v-model="item.sinceAgeLimit"
                            :options="dateOptions"
                            label="text"
                            :clearable="false"
                            class="date-select"
                            :searchable="false"
                            :reduce="(option => option.value)"
                            >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group
                    class="mx-50p"
                    >
                        <b-form-input
                        type="number"
                        v-model="item.numberUntilAgeLimit"
                        placeholder="Até"
                        min="1"
                        class="mw-50p"
                        />
                        <b-input-group-append>
                            <v-select
                            v-model="item.untilAgeLimit"
                            :options="dateOptions"
                            label="text"
                            :clearable="false"
                            class="date-select"
                            :searchable="false"
                            :reduce="(option => option.value)"
                            >
                            <span slot="no-options">Nenhuma opção selecionável.</span>
                            </v-select>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </td>
            <td>
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-danger"
                    @click="removeItem(index)"
                    v-if="index >= 2"
                >
                    Remover
                </b-button>
            </td>
            </tr>
        </tbody>
        </table>
        <small
            v-if="errorApi.list"
            class="text-danger"
        >
            {{ errorApi.list }}
        </small>
        </b-col>
        <b-col class="mt-1" v-if="multi" lg="4" md="12" sm="12">
            <label for="dose-input" class="label_size_vacina">Intervalo até a próxima dose (aprazamento)</label>
            <b-input-group id="dose-input">
                <b-form-input
                type="number"
                v-model="interval"
                placeholder="Intervalo"
                min="1"
                />
            <b-input-group-append>
                <v-select
                v-model="intervalDateOption"
                :options="dateOptions"
                label="text"
                :clearable="false"
                class="date-select"
                :searchable="false"
                >
                <span slot="no-options">Nenhuma opção selecionável.</span>
                </v-select>
            </b-input-group-append>
            </b-input-group>
            <small
                v-if="errorApi.interval"
                class="text-danger"
            >
                {{ errorApi.interval }}
            </small>
        </b-col>
        <b-col class="mt-1" v-if="multi" lg="3" md="12" sm="12">
            <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            @click="addNewItemInItemForm"
            >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Adicionar Dose
            </b-button>
        </b-col>
    </div>
</template>

<script>
import { BCardBody, BRow, BCol, BFormInput, BFormTextarea, BButton, BPopover, BFormGroup, BInputGroup, BInputGroupAppend} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
name: 'DoseConfiguration',
components: {
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BPopover,
    BFormGroup,
    vSelect
},
directives: {
    Ripple
},
props: {
  value: {
    type: Object,
    required: true
  },
  errorApi: {
    type: Array|Object,
    required: true
  },
  edit: {
    type: Boolean,
    default: false
  }
},
data() {
    const dayOption = {
        value: 'dias',
        text: 'Dia(s)',
    }
    
    return {
        dayOption: dayOption,
        invoiceData: {
            items: []
        },
        itemsOptions: [],
        itemsOptionsAll: [],
        typeDoseOptions: [
            { value: 'unica', text: 'Dose Única' },
            { value: 'unica', text: 'Dose Única sem vencimento' },
            { value: 'multi', text: 'Múltiplas Doses' }
        ],
        itemFormBlankItem: {
            dose: null,
            numberSinceAgeRecomended: null,
            numberUntilAgeRecomended: null,
            numberSinceAgeLimit: null,
            numberUntilAgeLimit: null,
            sinceAgeRecomended: "dias",
            untilAgeRecomended: "dias",
            sinceAgeLimit: "dias",
            untilAgeLimit: "dias"
        },
        dateOptions: [
            {
            value: 'dias',
            text: 'Dia(s)',
            },
            {
            value: 'meses',
            text: 'Mês(es)',
            },
            {
            value: 'anos',
            text: 'Ano(s)',
            },
        ],
        typeDose: null,
        interval: null,
        intervalDateOption: dayOption,
        filledForm: false
    }
},
mounted() {
    this.getDoses()
},
computed: {
    multi() {
        return this.typeDose ? this.typeDose.value === 'multi' : false
    }
},
methods: {
    getDoses(){
        const parameters = {
            colunaOrdenar: 'br_dose',
            ordem: 'asc',
            paginacao: false,
            ativo: true
        };

        this.$http.get(this.$api.getDose(), 
        { params: parameters })
        .then(({ data }) => {
            this.itemsOptions = data
            this.itemsOptionsAll = data
        })

        if(!this.edit){
            this.typeDose = this.typeDoseOptions[0]
        }
    },
    initWithTwoItens() {
        for (let i = 0; i < 2; i++){
            this.invoiceData.items.push(JSON.parse(JSON.stringify(this.itemFormBlankItem)))
        }
    },
    addNewItemInItemForm() {
      this.invoiceData.items.push(JSON.parse(JSON.stringify(this.itemFormBlankItem)))
    },
    removeItem(index) {
      this.invoiceData.items.splice(index, 1)
      this.updateDoseList()
    },
    updateDoseList() {
        const idsSelected = this.invoiceData.items.filter(item => item.dose).map(item => item.dose.id_dose)
        this.itemsOptions = this.itemsOptionsAll.filter(item => !idsSelected.includes(item.id_dose))
    },
    resetDoses() {
        this.invoiceData.items = []
        this.initWithTwoItens()
    }
},
watch: {
    typeDose: {
        handler() {
            this.$emit('typeDose', this.typeDose.text)
        },
        deep: true
    },
    invoiceData: {
        handler() {
            const items = this.invoiceData.items.filter(item => item.dose !== null)
            this.$emit('doseConfiguration', items)
        },
        deep: true
    },
    interval() {
        this.$emit('interval', this.interval)
    },
    intervalDateOption() {
        this.$emit('intervalDateOption', this.intervalDateOption)
    },
    'value.type': {
        handler(val) {
            if(val && this.edit && !this.filledForm){
                this.typeDose = this.typeDoseOptions.find(item => item.text === this.value.type)
                this.invoiceData.items = this.value.list
                this.updateDoseList()
                this.interval = this.value.interval
                this.intervalDateOption = this.dateOptions.find(item => item.value === this.value.intervalDateOption.value)
                this.filledForm = true
            }
        },
        deep: true
    }
}
}
</script>

<style lang="scss">
.table-dose {
    border-collapse: unset;
}
.date-select > div{
    border-radius: 0 0.357rem 0.357rem 0 !important;
}
.date-select > div > div > input.vs__search {
    width: 1px!important;
    padding: 0px !important;
}
.pr-2r {
    padding-right: 2rem !important;
}
.w-15px {
    width: 15px !important;
}

.vs--single .vs__dropdown-toggle {
    height: 100%;
}

.date-select > div > div > span.vs__selected {
    position: relative !important;
}

@media (min-width: 1400px) {
    .d-lg-block-dose {
        display: block !important;
    }

    .d-lg-none-dose {
        display: none !important;
    }
}
</style>